import React, { useState, useEffect, useReducer } from "react";
import { Tag, Icon, Progress } from "antd";
import axios from "axios";
import BranchCard from "../Assets/BranchCard.js";
import { StatusRender } from "../Assets/StatusRender";
import BranchMobileLoader from "../Assets/loaders/BranchMobileLoader";
import EmployeeMobileLoader from "../Assets/loaders/EmployeeMobileLoader";
import { getAccessToken, handleStatusError } from "./../../util/Auth";
import boldWords from "../Assets/boldWords";
import boldMain from "../Assets/boldMain";

const EquipmentMobileCard = props => {
  const APIRoute = process.env.REACT_APP_API_HOST;
  const { conditions, wildWords } = props;

  const {
    fleetBranchId,
    fldDesc,
    fleetNo,
    qtyAvail,
    available,
    terminated,
    reserved,
    catType,
    qtyOnHire,
    branchCode,
    isMain,
    description,
    type,
    regionCode,
    condition,
    bookedDeliveryDate,
    bookedPickupDate
  } = props.elem;

  const initialState = {
    employeesLoader: false,
    employees: [],
    employeesError: false,
    branchLoader: true,
    branchDetails: {},
    branchError: false,
    mainBranchDetails: {}
  };

  function reducer(state, action) {
    switch (action.type) {
      case "START_EMPLOYEES":
        return { ...state, employeesLoader: true, employeesError: false };
      case "SUCCESS_EMPLOYEES":
        return { ...state, employees: action.payload, employeesLoader: false };
      case "ERROR_EMPLOYEES":
        return {
          ...state,
          employees: [],
          employeesLoader: false,
          employeesError: true
        };
      case "START_BRANCH":
        return { ...state, branchLoader: true, branchError: false };
      case "SUCCESS_BRANCH":
        return { ...state, branchDetails: action.payload };
      case "SUCCESS_MAINBRANCH":
        return {
          ...state,
          mainBranchDetails: action.payload,
          branchLoader: false
        };
      case "ERROR_BRANCH":
        return {
          ...state,
          branchDetails: {},
          branchLoader: false,
          branchError: true
        };
      default: {
        return { ...state };
      }
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);

  const {
    employeesLoader,
    employees,
    branchDetails,
    branchMaster,
    branchLoader,
    employeesError,
    branchError
  } = state;

  const [toggle, setToggle] = useState(false);
  // variable to know if info was fetched already.
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!fetched && toggle) {
      setFetched(true);
      fetchEmployees();
      fetchBranchDetails();
      setFetched(true);
    }
  }, [toggle, fetched]);

  const fetchEmployees = async () => {
    dispatch({ type: "START_EMPLOYEES" });
    try {
      const queryParams =
        `Where.OperatorType=And` +
        `&Where.Operands[0].Field=fleetBranchId` +
        `&Where.Operands[0].FilterType=Equal` +
        `&Where.Operands[0].Value=${fleetBranchId}` +
        `&OrderBy[0].Field=Description` +
        `&OrderBy[0].Order=Asc`;
      const employeesList = await axios.get(
        `${APIRoute}baseplan/api/user?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
          }
        }
      );
      const selectedEmployees = employeesList.data.result.filter(
        e =>
          (e.role === "111" || e.role === "21") && e.branchCode === branchCode
      );
      dispatch({ type: "SUCCESS_EMPLOYEES", payload: selectedEmployees });
    } catch (error) {
      handleStatusError(error.response.status);
      dispatch({ type: "ERROR_EMPLOYEES" });
    }
  };

  const fetchBranchDetails = async () => {
    dispatch({ type: "START_BRANCH" });
    try {
      const params =
        `take=10` +
        `&Where.OperatorType=And` +
        `&Where.Operands[0].Field=id` +
        `&Where.Operands[0].FilterType=Equal` +
        `&Where.Operands[0].Value=${fleetBranchId}` +
        `&Where.Operands[1].Field=code` +
        `&Where.Operands[1].FilterType=Equal` +
        `&Where.Operands[1].Value=${branchCode.substring(0, 4)}`;

      const branchDetail = await axios.get(
        `${APIRoute}baseplan/api/branch/divisions?${params}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
          }
        }
      );
      dispatch({
        type: "SUCCESS_BRANCH",
        payload: branchDetail.data.result[0]
      });
      const masterParams =
        params +
        `&Where.Operands[2].Field=isMain` +
        `&Where.Operands[2].FilterType=Equal` +
        `&Where.Operands[2].Value=True`;

      const branchMaster = await axios.get(
        `${APIRoute}baseplan/api/branch/divisions?${masterParams}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAccessToken()}`
          }
        }
      );
      dispatch({
        type: "SUCCESS_MAINBRANCH",
        payload: branchMaster.data.result[0]
      });
    } catch (e) {
      handleStatusError(e.response.status);
      dispatch({
        type: "ERROR_BRANCH"
      });
    }
  };

  const renderEmployeeList = () => {
    if (employeesLoader || branchLoader) {
      return (
        <>
          <EmployeeMobileLoader />
          <EmployeeMobileLoader />
          <EmployeeMobileLoader />
        </>
      );
    }
    if (employeesError) {
      return (
        <div>
          Failed to retrieve contact information, please try again latter
        </div>
      );
    }
    if (employees.length === 0) {
      return <h2>No contact informattion available on baseplan</h2>;
    }
    return employees.map((employee, index) => (
      <div className="employeesListComponent" key={`Employee${index}`}>
        <div>
          <b>Name </b>
          <div>{employee.description}</div>
        </div>
        <div>
          <b>Role </b>
          <div>{employee.roleName}</div>
        </div>
        <div>
          <b>Email: </b>
          {employee.email ? (
            <a
              href={`mailto:${employee.email}?subject=re%3A%20Equipment%20(${fleetNo}-${fldDesc})`}
            >
              {employee.email}
            </a>
          ) : (
            "No record"
          )}
        </div>
        <div>
          <b>Phone: </b>
          {employee.phoneNumber ? (
            <a href={`tel:+1 ${employee.phoneNumber}`}>
              {employee.phoneNumber}
            </a>
          ) : (
            "No record"
          )}
        </div>
        <div>
          <b>Mobile Phone: </b>
          {employee.mobile ? (
            <a href={`tel:+1 ${employee.mobile}`}>{employee.mobile}</a>
          ) : (
            "No record"
          )}
        </div>
      </div>
    ));
  };

  const renderBranchContact = () => {
    if (branchLoader || employeesLoader) {
      return <BranchMobileLoader />;
    }
    if (branchError) {
      return <div>Failed to retrieve branch data, please try again latter</div>;
    }
    let cleanDivision = branchDetails.divisionName
      ? branchDetails.divisionName.replace(/\b(\w*Rain for Rent\w*)/i, "")
      : "No information available";
    if (Number(cleanDivision.substring(0, 4))) {
      cleanDivision = cleanDivision.substring(4).replace("-", "");
    }

    const list = [
      {
        top: "Division",
        bottom: cleanDivision
      },
      {
        top: "Phone",
        bottom: branchDetails.phone
          ? branchDetails.phone
          : branchMaster && branchMaster.phone
          ? branchMaster.phone
          : undefined,
        type: "phone"
      },
      {
        top: "Address",
        bottom: branchDetails.address
          ? branchDetails.address
          : branchMaster && branchMaster.address
          ? branchMaster.address
          : "No contact information is available please contact support."
      }
    ];
    return (
      <>
        {branchDetails.isMain && (
          <Tag
            color="#003d79"
            style={{ width: "min-content", marginTop: "25px" }}
          >
            Main branch
          </Tag>
        )}

        <BranchCard
          list={list}
          renderProgress={false}
          bookedPickupDate={bookedPickupDate}
          bookedDeliveryDate={bookedDeliveryDate}
        />
      </>
    );
  };

  const renderProgress = () => {
    if (employeesLoader || branchLoader) {
      return;
    }
    if (
      !bookedPickupDate ||
      !bookedDeliveryDate ||
      catType === "BULK" ||
      qtyOnHire !== qtyAvail
    ) {
      return null;
    }
    const start = new Date(bookedDeliveryDate).getTime() / 1000;
    const end = new Date(bookedPickupDate).getTime() / 1000;
    const today = new Date().getTime() / 1000;
    const p = Math.round(((today - start) / (end - start)) * 100);
    return (
      <div style={{ paddingTop: "15px" }}>
        <b>Due Progress</b>
        <Progress percent={p} showInfo={false} />
        <div className="PercentDate">
          <div>{`${bookedDeliveryDate.substring(
            5,
            7
          )}/${bookedDeliveryDate.substring(
            8,
            10
          )}/${bookedDeliveryDate.substring(0, 4)}`}</div>
          <div>{`${bookedPickupDate.substring(
            5,
            7
          )}/${bookedPickupDate.substring(8, 10)}/${bookedPickupDate.substring(
            0,
            4
          )}`}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="equipmentCardContainer">
      <div className="equipmentCard" key={`equipmentCard${fleetBranchId}`}>
        <div>
          <b>Description </b>
          <div dangerouslySetInnerHTML={boldWords(fldDesc, wildWords)}></div>
        </div>
        <div className="status">
          <b>Status</b>
          <StatusRender
            terminated={terminated}
            reserved={reserved}
            qtyAvail={qtyAvail}
            available={available}
            catType={catType}
            qtyOnHire={qtyOnHire}
            condition={condition}
            conditions={conditions}
          />
        </div>
        <div>
          <b>Branch </b>
          <div
            dangerouslySetInnerHTML={boldMain(description, branchCode, isMain)}
          ></div>
        </div>
        <div>
          <b>Product </b>
          <div
            dangerouslySetInnerHTML={boldWords(fleetNo, wildWords, true)}
          ></div>
        </div>
        <div>
          <b>Category </b>
          <div>{type}</div>
        </div>
        <div>
          <b>Region </b>
          <div>{regionCode}</div>
        </div>
      </div>

      {toggle && (
        <>
          {renderProgress()}
          {renderBranchContact()}
          {renderEmployeeList()}
        </>
      )}
      <div className="flexEnd">
        <Icon
          type={toggle ? "up" : "down"}
          onClick={() => setToggle(!toggle)}
        />
      </div>
    </div>
  );
};
export default EquipmentMobileCard;
